import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import styles from './NameSlideV4.css';

const cx = classnames.bind(styles);
const QUESTION = 'Last thing. What should we call you?';
const EMPTY_ERROR = 'Add your first name to continue.';

function NameSlideV4({ id, submitAnswer, userResponse = {} }) {
    const [name, setName] = useState(userResponse.text || '');
    const [error, setError] = useState('');

    const handleSubmit = event => {
        event.preventDefault();

        const trimmedName = name.trim();

        if (!trimmedName) {
            setError(EMPTY_ERROR);

            return;
        }

        logEvent(EVENT_TYPES.NAME_SUBMITTED);
        submitAnswer({ questionId: id, question: QUESTION, text: trimmedName })();
    };

    const handleChange = event => {
        setName(event.target.value);
        setError('');
    };

    return (
        <form className={styles.root} onSubmit={handleSubmit} noValidate>
            <h1 className={styles.title}>{QUESTION}</h1>
            <div className={styles.field}>
                <label htmlFor='memory-map-name' className={styles.label}>First name</label>
                <input
                    id='memory-map-name'
                    name='name'
                    className={cx('input', { invalid: Boolean(error) })}
                    value={name}
                    onChange={handleChange}
                    placeholder='First name'
                    autoComplete='given-name'
                    maxLength={24}
                    aria-invalid={Boolean(error)}
                    aria-describedby='memory-map-name-error'
                />
                <p className={styles.error} id='memory-map-name-error' role='alert'>{error}</p>
            </div>
            <div className={styles.footer}>
                <Button
                    type='sunset'
                    label='Continue'
                    inSlide
                    buttonProps={{ type: 'submit' }}
                />
            </div>
        </form>
    );
}

NameSlideV4.propTypes = {
    id: PropTypes.number.isRequired,
    submitAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object
};

export {
    NameSlideV4
};
